export default __webpack_public_path__ + "static/media/csgo.0e284b78.png";